export default "__VITE_ASSET__CATtt9vG__"